import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { VContainer } from 'vuetify/lib';

Vue.use(Vuetify, {
  components: { VContainer },
});

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#000000',
        secondary: '#ffffff',
      },
    },
  },
});
